import React, { useEffect, useRef } from 'react';

const ImageMarquee = () => {
  const containerRef = useRef(null);
  const scrollSpeed = 1; // pixels per frame

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let animationFrame;

    const scroll = () => {
      container.scrollLeft += scrollSpeed;
      if (container.scrollLeft >= container.scrollWidth / 2) {
        container.scrollLeft = 0;
      }
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div className="relative w-full overflow-hidden bg-white">
      {/* Left Fade */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-white to-transparent"></div>

      {/* Right Fade */}
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-white to-transparent"></div>

      <div
        ref={containerRef}
        className="flex w-full overflow-x-scroll scrollbar-hide"
        style={{ scrollBehavior: 'auto', whiteSpace: 'nowrap' }}
      >
        {/* Scrolling Images */}
        <div className="flex w-max">
          {Array.from({ length: 9 }).map((_, idx) => (
            <React.Fragment key={idx}>
              <img
                src="/images/HeroImage1.webp"
                alt="Hero Image 1"
                className="ml-4 h-[350px] w-auto object-cover md:h-[500px]"
              />
              <img
                src="/images/HeroImage2.webp"
                alt="Hero Image 2"
                className="ml-4 h-[350px] w-auto object-cover md:h-[500px]"
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageMarquee;
